import React from 'react';
import { InstantSearch, useHits } from 'react-instantsearch-hooks';
import { useFormat } from 'helpers/hooks/useFormat';
import Search from 'components/commercetools-ui/atoms/search-algolia';
import { Category } from 'shared/types/product/Category';
import { largeDesktop } from 'helpers/utils/screensizes';
import useMediaQuery from 'helpers/hooks/useMediaQuery';

interface Props {
  query: string;
  categories: Category[];
  noContentSuggestions?: number;
}

const SearchHeader: React.FC<Props> = ({ query, categories, noContentSuggestions }) => {
  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });

  const { results } = useHits();
  const [isLargeDesktop] = useMediaQuery(largeDesktop);

  const scrollTo = (ele: HTMLElement) => {
    const position = ele.getBoundingClientRect();
    window.scrollTo({
      top: position.top + window.scrollY - (isLargeDesktop ? 180 : 140),
      behavior: 'smooth',
    });
  };
  const scrollToDesktop = (id: string) => {
    const ele = document.getElementById(id);
    
    if (ele) {
      scrollTo(ele);
    }
  };

  return (
    <div>
      <h1 className="mb-18 text-40 font-medium leading-[3.25rem] lg:mb-0 lg:text-26 lg:leading-[2.5rem] 3xl:mb-24 3xl:text-48 3xl:leading-[3.25rem]">
        {formatProductMessage({
          id: 'search',
          defaultMessage: 'Search',
        })}{' '}
        {/* <span className="font-medium">“{query}”</span> */}
      </h1>
      <div className="relative">
        <span className="absolute left-9 top-2 z-[12] pt-16 lg:pt-12 3xl:pt-19 ">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" className="">
            <path
              d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
              stroke="#191919"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        {/* <Search categories={categories} searchedQuery={query} searchPage={true} /> */}
         <Search categories={categories} searchedQuery={query}/>
        {/* <XMarkIcon
        className="absolute right-[20%] z-[999] !h-24 !w-24 -translate-y-1/2 text-primary-black stroke-2 hover:cursor-pointer lg:right-[4.5rem]"
          onClick={() => cleanUp()}
      /> */}
      </div>
      <h4 className="mt-10 text-12 font-normal leading-[1.5rem] text-[##808080] 2xl:text-16">
        <span className="hover:cursor-pointer hover:underline" onClick={() => scrollToDesktop('product-suggestions')}>
          {formatProductMessage({
            id: 'found.products',
            defaultMessage: '{count} Results for',
            values: { count: results?.nbHits ?? 0 },
          })}
        </span>
        {', '}
        <span className="hover:cursor-pointer hover:underline" onClick={() => scrollToDesktop('content-suggestions')}>
          {formatProductMessage({
            id: 'found.content',
            defaultMessage: '{count} Results for',
            values: { count: noContentSuggestions ?? 0 },
          })}
        </span>{' '}
        for
        <span className="font-semibold text-black"> “{query}”</span>
      </h4>
    </div>
  );
};
export default SearchHeader;